import { useQuery } from '@tanstack/react-query';
import { getBrandImage } from '../../api/brand.ts';

export default function useBrandImage(brandId: string, imageId: string) {
  return useQuery({
    queryKey: ['brands', brandId, 'images', imageId],
    queryFn: async () => {
      if (!brandId || !imageId) return null;
      const res = await getBrandImage(brandId, encodeURIComponent(imageId));
      return res?.signedUrl || null;
    },
    enabled: !!brandId && !!imageId,
  });
}
